import { QueryClient } from '@tanstack/react-query'
import { ErrorApi } from '@/api/errores'

/**
 * Capa de datos: caché, reintentos e invalidación.
 *
 * Dos reglas que no son el valor por defecto de la librería:
 *
 * 1. **Solo se reintenta lo que puede cambiar de resultado al repetirlo.** Un
 *    422 o un 404 no se reintentan nunca; una caída de red o un 5xx sí.
 * 2. **Las escrituras no se reintentan aquí.** La decisión depende de si
 *    llevan clave de idempotencia, y eso lo sabe `api/cliente.ts`. Reintentar
 *    un POST sin clave duplica documentos.
 */
export function crearClienteDeConsultas(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (intento, error) => {
          if (intento >= 2) return false
          if (error instanceof ErrorApi) return error.esReintentable
          return true
        },
      },
      mutations: {
        retry: false,
      },
    },
  })
}
